export const getPermission = async (): Promise<NotificationPermission> => {
    try {
        return Notification.permission as NotificationPermission;
    } catch (_e) {
        console.error(_e);
        try {
            return Notification?.requestPermission() ?? 'denied';
        } catch (e) {
            console.error(e);
            // if not supported, e.g. in Safari private mode/old Safari versions
            return 'denied';
        }
    }
};
